import React from 'react';
import styled from 'styled-components';

// Import carousel images
import image1 from '../../assets/images/1.jpg';
import image2 from '../../assets/images/2.jpg';
import image3 from '../../assets/images/3.jpg';

const CarouselContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
  height: 500px;
`;

const CarouselSlide = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
  background-position: center;
  position: relative;
`;

const CarouselOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 1.5rem;
  text-align: left;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 1rem;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    position: relative;
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const CarouselTitle = styled.h2`
  color: white;
  margin-bottom: 0.5rem;
  font-size: 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1.5rem;
  }
`;

const CarouselDescription = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  margin-bottom: 0;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1rem;
  }
`;

const carouselItems = [
  {
    image: image1,
    title: 'Welcome to Tandara Lodge',
    description: 'Providing exceptional care and quality of life in Sheffield, Tasmania.'
  },
  {
    image: image2,
    title: 'Residential Aged Care',
    description: 'A comfortable and caring environment for our residents.'
  },
  {
    image: image3,
    title: 'Community Care',
    description: 'Supporting the Kentish Municipality with quality health services.'
  }
];

const Carousel = () => {
  // Just use the first carousel item for now to simplify
  const item = carouselItems[0];
  
  return (
    <CarouselContainer>
      <CarouselSlide image={item.image}>
        <CarouselOverlay>
          <CarouselTitle>{item.title}</CarouselTitle>
          <CarouselDescription>{item.description}</CarouselDescription>
        </CarouselOverlay>
      </CarouselSlide>
    </CarouselContainer>
  );
};

export default Carousel;
